import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, Loading, Modal, Text } from '@reveni-io/reveni-ui'

import { cancelParcelValues } from '../constants'
import CancelParcelSelector from './CancelParcelSelector/CancelParcelSelector'
import * as Styles from './styles'

const CancelParcelModal = ({ show, cancelingParcel, onClose, onCancelParcel, isOrderCancellable, loading }) => {
  const { t } = useTranslation()
  const [selectedOption, setSelectedOption] = useState()

  useEffect(() => {
    if (show) {
      setSelectedOption(cancelParcelValues.no)
    }
  }, [show])

  const handleOnCancelParcel = () => {
    onCancelParcel(selectedOption)
  }

  return (
    <Modal title={t('Cancelar envío')} show={show} size="l" onClose={onClose}>
      <Loading show={loading} height={350}>
        <Styles.MainContainer>
          <Text type="bodyMRegular">
            {t(
              'Este envío se cancelará y cualquier información de empaquetado, y la etiqueta de envío y otros documentos que puedan existir también serán anulados.'
            )}
          </Text>
          <CancelParcelSelector value={selectedOption} onChange={setSelectedOption} disabled={!isOrderCancellable} />
          <Alert type="warning">{t('Esta acción no se puede deshacer. ¿Quieres continuar?')}</Alert>
          <Styles.ActionsContainer>
            <Button fullWidth variant="outlined" onClick={onClose}>
              {t('Atrás')}
            </Button>
            <ButtonWithSpinner
              fullWidth
              defaultLabel={t('Cancelar envío')}
              loadingLabel={t('Cancelar envío')}
              disabled={cancelingParcel}
              loading={cancelingParcel}
              onClick={handleOnCancelParcel}
            />
          </Styles.ActionsContainer>
        </Styles.MainContainer>
      </Loading>
    </Modal>
  )
}

export default CancelParcelModal
